import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=767d723e&scoped=true&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldList.vue?vue&type=style&index=0&id=767d723e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d723e",
  null
  
)

export default component.exports